/**
 * App-wide Live vs Edit preference for the session (Directory, Add Module, Document, Search).
 * Live (view / Table of Procedures): isViewMode === true
 * Edit (classic): isViewMode === false
 *
 * Keeps `document_is_view_mode` and `products_use_classic_appbar` in sync so all screens agree.
 */

const STORAGE_DOCUMENT_VIEW = "document_is_view_mode";
const STORAGE_PRODUCTS_CLASSIC = "products_use_classic_appbar";

/** @returns {boolean | null} null if neither key is set */
export function getGlobalAppViewMode() {
  try {
    const d = sessionStorage.getItem(STORAGE_DOCUMENT_VIEW);
    if (d === "true") return true;
    if (d === "false") return false;
    const p = sessionStorage.getItem(STORAGE_PRODUCTS_CLASSIC);
    if (p === "false") return true;
    if (p === "true") return false;
  } catch {
    /* ignore */
  }
  return null;
}

export function setGlobalAppViewMode(isViewMode) {
  try {
    sessionStorage.setItem(
      STORAGE_DOCUMENT_VIEW,
      isViewMode ? "true" : "false",
    );
    sessionStorage.setItem(
      STORAGE_PRODUCTS_CLASSIC,
      isViewMode ? "false" : "true",
    );
  } catch {
    /* ignore */
  }
}

export function clearGlobalAppViewModePreferences() {
  try {
    sessionStorage.removeItem(STORAGE_DOCUMENT_VIEW);
    sessionStorage.removeItem(STORAGE_PRODUCTS_CLASSIC);
  } catch {
    /* ignore */
  }
}
